import React from 'react';

const ChartCard = ({ title, subtitle,children }) => {
  return (
    <div className=' shadow-metafit-shadow bg-white border rounded-[10px] w-full'>
      <div className='text-base font-semibold text-dark p-4  border-b'>{title} {subtitle && <span className='text-[12px] font-normal text-gray60'>{subtitle}</span>}</div>
            {children}
    </div>
  );
};

export default ChartCard;
